import React, {FC} from "react"
import styled, {css} from "styled-components"

import {Label} from "@irati/ui/src/Typography"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import {User} from "@irati/types"
import Flex from "@irati/ui/src/Flex"

interface WrapperProps {
  hasBackground?: boolean
  flush?: boolean
}
const Wrapper = styled(Flex)<WrapperProps>`
  margin-bottom: ${({flush}) => (flush ? 0 : "10px")};
  text-align: left;
  ${({theme, hasBackground}) =>
    hasBackground &&
    css`
      padding: ${theme.spacing.half} ${theme.spacing.one};
      border-radius: ${theme.spacing.eight};
      background-color: ${theme.colors.utility.highlight};
    `}
`

interface Props {
  createdBy: User
  bold?: boolean
  hasBackground?: boolean
  flush?: boolean
}

const WhoCreated: FC<Props> = ({createdBy, bold, hasBackground, flush}) => {
  return (
    <Wrapper hasBackground={hasBackground} flush={flush} alignItems="center">
      <ProfilePicture user={createdBy} marginRight small />
      <Label weight={bold ? "bold" : "default"}>{firstnameLastname(createdBy)}</Label>
    </Wrapper>
  )
}

export default WhoCreated
